var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaThriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01798 26.3051C9.14662 27.9196 14.0595 29.1871 16.3798 26.1645C18.8895 27.3649 23.029 26.9928 26.3992 25.1134C26.8679 24.8521 27.3113 24.5222 27.5828 24.0593C28.1958 23.0143 28.2103 21.5644 27.092 19.4251C25.2275 14.7707 21.8741 10.6851 20.5202 9.04212C20.2422 8.78865 18.4688 8.42868 17.3873 8.08279C16.9096 7.93477 16.0201 7.83664 14.9562 9.23862C14.4518 9.90329 12.1607 11.5357 15.0677 12.6335C15.5181 12.7481 15.8492 12.9594 17.9039 12.584C18.1715 12.5376 18.8396 12.584 19.3104 13.4104L20.2937 14.8166C20.3852 14.9475 20.4446 15.0981 20.4628 15.2568C20.6351 16.7557 20.6295 18.6323 21.4652 19.5826C20.1744 18.6492 16.8012 17.5406 14.2596 20.6951M8.00195 18.94C9.21015 17.791 12.712 15.9759 16.418 18.5216",
    stroke: "#7463B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaThriveIcon);
export default __webpack_public_path__ + "static/media/triva_thrive-icon.1008f8f82e6b1948d005446f7e5ede11.svg";
export { ForwardRef as ReactComponent };